export default {
  manual: 'Manuel',
  filters: {
    status: 'Statut',
    event_type: "Type d'événement",
  },
  columns: {
    event: 'Événement',
    status: 'Statut',
    attempts: 'Tentatives',
    last_http_status: 'Dernier statut HTTP',
    created_at: 'Créée le',
  },
  statuses: {
    pending: 'En attente',
    delivered: 'Livrée',
    failed: 'Échouée',
  },
  buttons: {
    details: 'Détails',
    resend: 'Renvoyer',
  },
  detail: {
    title: 'Détails de la livraison',
    event: 'Événement',
    attempts: 'Tentatives',
    no_attempts: "Aucune tentative pour l'instant.",
    no_response: 'aucune réponse',
    payload: 'Charge utile',
  },
  toasts: {
    load_error: 'Impossible de charger les livraisons.',
    resend_error: 'Impossible de renvoyer la livraison.',
    resent: 'Livraison mise en file pour renvoi.',
  },
};
